import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { setOpenModalTerceirosVideo, setRedirectTerceiros } from "../../../../../store/actions/termos";
import ModalVideo from "../../../../../components/ModalVideo";

import S from "./styles";

export default function ModalTerceirosVideo() {
  const terceirosReducer = useSelector((state) => state.terceiros);
  const dispatch = useDispatch();

  const handleOk = () => {
    dispatch(setOpenModalTerceirosVideo(false));
    if(!terceirosReducer.openModalInformativo)
      dispatch(setRedirectTerceiros(true));
  };
  
  function handleModalStorage() {
    dispatch(setOpenModalTerceirosVideo(false));
    localStorage.setItem("naoExibirVideoTerceiros", true);
    if(!terceirosReducer.openModalInformativo)
      dispatch(setRedirectTerceiros(true));
  }

  return (
    terceirosReducer.openModalVideo && (
      <ModalVideo
        onClose={() => dispatch(setOpenModalTerceirosVideo(false))}
        onConfirm={handleOk}
        handleModalStorage={() => handleModalStorage()}
        title="Prezado cliente:"
        buttonText="OK"
        MessageInline="Não exibir mais esta mensagem"
      >
        <S.Content>
          <iframe
            title="Informativo"
            id="panda-2c465324-b5ee-4c6f-92b8-43201a995370"
            src="https://player-vz-058a0fa1-17b.tv.pandavideo.com.br/embed/?v=2c465324-b5ee-4c6f-92b8-43201a995370"
            style={{ border: 'none' }}
            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
            allowfullscreen="true"
            width="720"
            height="360"
            fetchpriority="high">
          </iframe>
        </S.Content>
      </ModalVideo>
    )
  );
};
